import { useQuery } from '@tanstack/react-query';
import apiRoutes from '../apiRoutes';
import { useAppDispatch } from '../app/hooks';
import {
  setTotalFundingBalance,
  setTotalSpotBalance,
} from '../features/userSlice';
import api from '../utils';

export const useCoinData = ({
  allow_buy = true,
  allow_sell = true,
}: {
  allow_buy?: boolean;
  allow_sell?: boolean;
}) => {
  const getCoinData = async () => {
    const res = await api.post(
      apiRoutes.components,
      (allow_buy || allow_sell) && {
        trans_type: allow_sell ? 'sell' : 'buy',
        // filters: removeFalse({
        //   allow_buy,
        //   allow_sell,
        // }),
      }
    );
    return res.data;
  };

  const { data, ...rest } = useQuery<FetchComponentsData>({
    queryKey: ['coin_data', allow_buy, allow_sell],
    queryFn: getCoinData,
  });

  //   console.log('coin hook data', data);

  return {
    coinData: data?.info.rates,
    ...rest,
  };
};

export const useWalletData = (type?: string) => {
  const dispatch = useAppDispatch();
  const fetchWalletData = async () => {
    const res = await api.post(apiRoutes.walletData, {
      type,
    });
    return res.data;
  };
  const { data, ...rest } = useQuery<WalletData>({
    queryKey: ['wallet_data'],
    queryFn: fetchWalletData,
    onSuccess: (data) => {
      if (data?.success) {
        dispatch(setTotalSpotBalance(data?.info.total_spot));
        dispatch(setTotalFundingBalance(data?.info.total_funding));
      }
    },
    refetchOnWindowFocus: true,
  });

  return {
    walletData: data?.info,
    ...rest,
  };
};
